export const LABELS = ["send_to_ero", "outreach"] as const;

export type CaseNoteLabel = typeof LABELS[number];

export const CASE_NOTE_LABELS: Record<CaseNoteLabel, string> = {
  send_to_ero: "Sent to External Reviewer",
  outreach: "Outreach",
} as const;

export interface CaseNoteCreateRequest {
  readonly case_id: number;
  readonly content?: string;
  readonly communication_id?: number;
  readonly labels?: CaseNoteLabel[];
}
